// src/redux/imageSlice.js

import { createSlice } from '@reduxjs/toolkit';
import { generateRandomId } from '../utils/basic_utils';

const initialState = {
  uuid: generateRandomId(10),
  spectralis_high_res: {
    file: null,
    url: null, 
    path: null,
    probes: null
  },
  annotated_spectralis: {
    file: null,
    url: null, 
    path: null,
    probes: null
  },
  spectralis_report: {
    file: null,
    url: null, 
    path: null,
    probes: null
  },
  maia_tgz_file: {
    file: null,
    url: null, 
    path: null,
    options: [],
    probes: null,
    selectedOption: null
  },
  selectedImage: null,
  registeredUrl: null,
  measurementData: {}, // Added this line to handle measurement data
  centerPoint: null,
  grid: null,
  loaded_pattern: null,
  etdrs: null
};

export const imageSlice = createSlice({
  name: 'images',
  initialState,
  reducers: {
    setImages: (state, action) => {
      state[action.payload.name] = action.payload.value;
    },
    setImageMeta: (state, action) => {
      state[action.payload.name] = {
        ...state[action.payload.name], ...action.payload.value
      };
    }
  },
});

export const { setImages, setImageMeta } = imageSlice.actions; 

export const selectImages = (state) => state.images;

export default imageSlice.reducer;
